.Backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: var(--context-menu-z-index, 25);
}

.ContextMenu {
  position: fixed;
  flex-direction: column;
  display: flex;
  border-radius: var(--context-menu-border-radius, 0.25rem);
  overflow: hidden;
  white-space: nowrap;
  filter: var(--context-menu-filter);
  padding: var(--context-menu-padding, 0.25rem 0);
  background-color: var(--context-menu-background-color, rgba(0, 0, 0, 0.9));
  border: var(--context-menu-border-size) solid var(--context-menu-border-color);
  overflow: hidden;
}
.ContextMenu:focus {
  outline: none;
}
